import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, ArrowLeft } from 'lucide-react';

export default function PendingApprovalPage() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="border-[#E2E8F0] shadow-none">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-[#FEF3C7] rounded-full flex items-center justify-center">
                <Clock className="h-8 w-8 text-[#F59E0B]" />
              </div>
            </div>
            <CardTitle className="font-heading text-2xl font-bold text-[#0F172A]">
              APPLICATION UNDER REVIEW
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-6">
            <p className="text-[#64748B]">
              Thank you for signing up! Your application is currently under review by our admin team.
            </p>
            <p className="text-[#64748B]">
              You will receive an email notification once your account is approved.
            </p>
            <div className="pt-4">
              <Button
                variant="outline"
                onClick={handleLogout}
                className="border-[#E2E8F0] text-[#64748B] hover:text-[#0F172A]"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
